module.exports = __webpack_public_path__ + "img/flowers7.894f6c88.jpg";